module.exports = __webpack_public_path__ + "assets/img/wxpay.b113d4c5.svg";